/**
 * Contact — split layout: form on the left, channels on the right.
 */
import React from 'react';
import MarketingLayout from './MarketingLayout';
import Section from './components/Section';
import ContactForm from './components/ContactForm';
import useSiteConfig from './useSiteConfig';
import { COLOR, FONT, RADIUS } from '../../components/ss/tokens';

export default function Contact() {
  const { config } = useSiteConfig();
  const contact = config.contact;
  const fb = config.ui?.fallbacks || {};

  return (
    <MarketingLayout>
      <Section
        background="#fff"
        paddingY={88}
        eyebrow={contact?.eyebrow || fb.contactEyebrow}
        title={contact?.title || fb.contactTitle}
        subtitle={contact?.subtitle}
        align="center"
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1.4fr 1fr',
            gap: 40,
            alignItems: 'start',
          }}
          className="hhms-contact-grid"
        >
          <div>
            <ContactForm />
          </div>

          <aside
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 16,
            }}
          >
            {(contact?.channels || []).map((c, i) => (
              <a
                key={i}
                href={c.href || undefined}
                style={{
                  background: COLOR.grayBg,
                  border: `1px solid ${COLOR.grayBorder}`,
                  borderRadius: RADIUS.md,
                  padding: 18,
                  textDecoration: 'none',
                  color: COLOR.text,
                  display: 'block',
                }}
              >
                <div
                  style={{
                    fontSize: FONT.size.sm,
                    fontWeight: FONT.weight.bold,
                    color: COLOR.blue,
                    textTransform: 'uppercase',
                    letterSpacing: '1.4px',
                  }}
                >
                  {c.label}
                </div>
                <div
                  style={{
                    marginTop: 4,
                    fontSize: FONT.size.md,
                    color: COLOR.text,
                    lineHeight: 1.5,
                    wordBreak: 'break-word',
                  }}
                >
                  {c.value}
                </div>
              </a>
            ))}
          </aside>

          <style>{`
            @media (max-width: 820px) {
              .hhms-contact-grid { grid-template-columns: 1fr !important; }
            }
          `}</style>
        </div>
      </Section>
    </MarketingLayout>
  );
}
